import { render, staticRenderFns } from "./qaDetail.vue?vue&type=template&id=eeacebb0&scoped=true"
import script from "./qaDetail.vue?vue&type=script&lang=js"
export * from "./qaDetail.vue?vue&type=script&lang=js"
import style0 from "./qaDetail.vue?vue&type=style&index=0&id=eeacebb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@6.11.0_prettier@3.3.2_vue-_at3he3kewep5rtdjf2lcevutue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeacebb0",
  null
  
)

export default component.exports